import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {crmStore} from '@components/crm/crm-store'
import {useDealDetails} from '@components/right-panel/crm/about-client/use-deal-details'
import {cn} from '@containers/html-utils'

interface DealSubtitleProps {
  deal: Hub
  className?: string
}

export const DealSubtitle = observer((props: DealSubtitleProps) => {
  const dealDetails = useDealDetails(props.deal)

  const role = crmStore.getCrmRoleOfHub(props.deal)
  const subtitle =
    role === 'contact'
      ? Lang.msg.crm.contactPerson
      : role === 'organization'
        ? Lang.msg.crm.organization
        : dealDetails.subtitle

  return (
    <div className={cn('text-14 text-secondary', props.className)}>
      {subtitle}
    </div>
  )
})
